import { mobileWidth } from "./modules/utility";

const floatingVideo = document.querySelector(".floating-video") as HTMLElement;

// Set up video
if (floatingVideo && !mobileWidth.matches) {
    import(/*webpackChunkName: "videos" */ "./modules/videos").then(video => video.createHospitalVideo(floatingVideo));
}
